import { render, staticRenderFns } from "./PMS.vue?vue&type=template&id=1d2032af&scoped=true"
import script from "./PMS.vue?vue&type=script&lang=js"
export * from "./PMS.vue?vue&type=script&lang=js"
import style0 from "./PMS.vue?vue&type=style&index=0&id=1d2032af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2032af",
  null
  
)

export default component.exports